<template>
  <div class="bg-white">
    <div class="flex justify-between items-start shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6">
        <p class="font-bold text-lg mb-6">Info Armada</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500">{{ armadaDetail.id }}</p>
        </div>
        <div class="mb-6 flex gap-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Truck</label>
            <p class="text-neutral-500">{{ armadaDetail.vehicle_name }}</p>
          </div>
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tahun Kendaraan</label>
            <p class="text-neutral-500">{{ armadaDetail.vehicle_production_year }}</p>
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Plat Armada</label>
          <p class="text-neutral-500">{{ armadaDetail.vehicle_plat_id }}</p>
        </div>
        <p class="font-bold text-lg mb-6">Tipe Aset</p>
        <div class="mb-6 flex gap-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Aset</label>
            <p class="text-neutral-500 capitalize">{{ armadaDetail.ownership_type }}</p>
          </div>
          <div class="w-44 mdmax:flex-1 mdmax:w-auto" v-if="armadaDetail.ownership_type === 'partner'">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kepemilikan</label>
            <p class="text-neutral-500">{{ armadaDetail?.ownership_assigned?.name }}</p>
          </div>
        </div>
        <div class="shadow-border p-6 bg-neutral-200 rounded-md" v-if="armadaDetail.ownership_type === 'partner'">
          <div class="flex items-start gap-6 mb-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <p class="text-sm font-medium mb-1 text-neutral-700">Nama</p>
              <p class="text-neutral-500">{{ armadaDetail?.ownership_assigned?.name }}</p>
            </div>
            <div class="">
              <p class="text-sm font-medium mb-1 text-neutral-700">No. Handphone</p>
              <p class="text-neutral-500">{{ armadaDetail?.ownership_assigned?.phone_number }}</p>
            </div>
          </div>
          <div class="mb-6">
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat</p>
            <p class="text-neutral-500">{{ armadaDetail?.ownership_assigned?.address }}</p>
          </div>
          <div class="">
            <p class="text-sm font-medium mb-1 text-neutral-700">Total Aset</p>
            <p class="text-neutral-500">{{ armadaDetail?.ownership_assigned?.total_vehicle }}</p>
          </div>
        </div>
        <div class="" v-if="armadaDetail.ownership_type === 'company'">
          <p class="text-sm font-medium mb-1 text-neutral-700">Kurir</p>
          <div class="mb-1" v-for="kurir in armadaDetail.driver_assigned" :key="kurir.id">
            <p class="text-neutral-500">{{ kurir.name }}</p>
          </div>
        </div>
      </div>
      <div class="flex-1 p-6">
        <p class="font-bold text-lg mb-6">Dokumen</p>
        <div class="flex gap-6 mb-6">
          <div class="w-32">
            <p class="text-sm font-medium mb-1 text-neutral-700">STNK</p>
            <div class="border p-2 w-full rounded-md">
              <a :href="armadaDetail.stnk_file_url" target="_blank">
                <img :src="armadaDetail.stnk_file_url" />
              </a>
            </div>
          </div>
          <div class="w-32">
            <p class="text-sm font-medium mb-1 text-neutral-700">BPKB</p>
            <div class=" border p-2 w-full rounded-md">
              <a :href="armadaDetail.bpkb_file_url" target="_blank">
                <img :src="armadaDetail.bpkb_file_url" />
              </a>
            </div>
          </div>
        </div>
        <p class="font-bold text-lg mb-6">Foto Kendaraan</p>
        <div class="flex gap-6 mdmax:flex-wrap">
          <div class="border p-2 w-32 rounded-md">
            <a :href="armadaDetail.vehicle_photo_url" target="_blank">
              <img :src="armadaDetail.vehicle_photo_url" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <Button buttonText="Hapus" @action="toggleDeleteModal()" type="delete" :size="isMobile ? 'full' : 'regular'" />
      <Button buttonText="Edit" @action="edit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
    <Modal :modalVisible="visibleDeleteModal" @close="toggleDeleteModal" id="delete-modal">
      <template slot="modal-content">
        <div class=" text-cente mt-6 mb-4">Apakah Anda yakin akan menghapus partner ini?</div>
        <div class="flex justify-center items-center gap-4">
          <Button buttonText="Ya" @action="deleteItem()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Tidak" @action="toggleDeleteModal()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('armada', ['armadaDetail']),
    vehicleId() {
      return this.$route.params.id
    },
    partnerId() {
      return this.userData?.user?.group_id
    }
  },
  data() {
    return {
      visibleDeleteModal: false
    }
  },
  created() {
    this.getVehicleInfo()
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('armada', ['getArmadaDetail', 'deleteArmada']),
    getVehicleInfo() {
      this.getArmadaDetail({
        partnerId: this.partnerId,
        vehicleId: this.vehicleId
      }).then(res => {
        // console.log(res)
      })
    },
    toggleDeleteModal() {
      this.visibleDeleteModal = !this.visibleDeleteModal
    },
    deleteItem() {
      this.showLoading()
      this.deleteArmada({
        partnerId: this.partnerId,
        vehicleId: this.vehicleId
      }).then(() => {
        this.toggleDeleteModal()
        this.hideLoading()
        this.$router.push('/armada')
      })
    }
  }
}
</script>
